import {
  Box,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { ReactNode } from "react";
import { ReactService } from "../../services/react.service";
import useScreen from "../common/UseScreen";
import Image from "../common/Image";
import StyledPageBannerTextContainer from "../../styled-cmps/page-banner-text-container";

interface PageBannerProps {
  imageSrc: string;
  children?: ReactNode;
  title?: string;
  subtitle?: string;
  containerSx?: SxProps;
  height?: string;
}

enum PageBannerSlots {
  CONTENT = "content",
}

const PageBanner = ({
  children,
  imageSrc,
  title,
  subtitle,
  height,
  containerSx,
}: PageBannerProps) => {
  const { isDesktop, isXl, isMobile } = useScreen();
  const theme = useTheme();
  const childrenArray = React.Children.toArray(children);

  const textBreakpoint = useMediaQuery(theme.breakpoints.down(1044));

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        ...containerSx,
        height: height || (isDesktop ? (isXl ? "350px" : "318px") : "350px"),
      }}
    >
      <Image
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: !isMobile ? "10px" : "0",
        }}
        src={imageSrc}
      />
      <StyledPageBannerTextContainer>
        <Typography
          sx={{
            color: "white",
            fontWeight: "500",
            fontSize: textBreakpoint ? "25px" : "32px",
            marginBottom: "5px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: "white",
            fontSize: textBreakpoint ? "16px" : "18px",
            fontWeight: "300",
            marginBottom: children ? "20px" : "0",
          }}
        >
          {subtitle}
        </Typography>
        {children &&
          ReactService.renderSlot(childrenArray, PageBannerSlots.CONTENT)}
      </StyledPageBannerTextContainer>
    </Box>
  );
};

export default PageBanner;
